module.exports = __webpack_public_path__ + "static/media/euchorthippus_declivus_008_APA.99f41882.mp3";